/* unplugin-vue-components disabled */import { render } from "./Review.vue?vue&type=template&id=0f7c6be2&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import "./Review.vue?vue&type=style&index=0&id=0f7c6be2&lang=scss&scoped=true"

import exportComponent from "/var/workhome/jenkins/jenkins_home/workspace/prod-vue-mt-comp-sso/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7c6be2"]])

export default __exports__